export default __webpack_public_path__ + "static/media/a9.e1f34340.webp";